/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import { Box, CardMedia, IconButton, Typography } from "@mui/material";
import LinkedinB from "assets/Icons/LinkedinB.svg";
import PrintB from "assets/Icons/PrinterB.svg";
import ShareNetworkB from "assets/Icons/ShareNetworkB.svg";
import TwitterB from "assets/Icons/TwitterB.svg";
import React from "react";

// eslint-disable-next-line react/prop-types
function BlogShare({ tags }) {
  const pageUrl = window.location.href;

  const tagList = tags
    ?.split(/\s+/)
    .map((tag) => tag.trim())
    .filter((tag) => tag.length > 1 && !/^\d+$/.test(tag))
    .slice(0, 4);

  // Share Functionality
  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: document.title,
          text: "Check out this amazing blog!",
          url: pageUrl,
        });
      } catch (error) {
        console.error("Error sharing:", error);
      }
    } else {
      alert("Native sharing not supported on this device.");
    }
  };

  const socialIcons = [
    {
      name: "LinkedIn",
      url: `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(pageUrl)}`,
      icon: LinkedinB,
    },
    {
      name: "Twitter",
      url: `https://twitter.com/intent/tweet?url=${encodeURIComponent(pageUrl)}`,
      icon: TwitterB,
    },
    {
      name: "Print",
      action: () => window.print(),
      icon: PrintB,
    },
    {
      name: "Share",
      action: handleNativeShare,
      icon: ShareNetworkB,
    },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row", md: "row" },
        alignItems: "center",
        gap: "24px",
        alignSelf: "stretch",
        justifyContent: "space-between",
        padding: "16px",
      }}
    >
      <Box sx={{ display: "flex", gap: "16px" }}>
        <Typography
          sx={{
            color: "#8B8E90",
            fontFamily: "Inter",
            fontSize: { xs: "16px", sm: "19px", md: "23px" },
            fontWeight: 400,
          }}
        >
          Tags:
        </Typography>

        {tagList.map((word, index) => (
          <Typography
            key={index}
            sx={{
              color: "#5EADCC",
              fontFamily: "Inter",
              fontSize: { xs: "16px", sm: "19px", md: "23px" },
              fontWeight: 400,
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            {word}
          </Typography>
        ))}
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
        {socialIcons.map(({ name, url, action, icon }) => (
          <IconButton
            key={name}
            component={url ? "a" : "button"}
            href={url || undefined}
            target={url ? "_blank" : undefined}
            rel={url ? "noopener noreferrer" : undefined}
            onClick={action || undefined}
          >
            <CardMedia
              component="img"
              src={icon}
              alt={`Share on ${name}`}
              sx={{ width: 24, height: 24 }}
            />
          </IconButton>
        ))}
      </Box>
    </Box>
  );
}

export default BlogShare;
